export default __webpack_public_path__ + "static/media/stock-2.68de4d50.png";